import { BasicEntity, CatalogGridItem } from '@/types/Catalogs'

export class DataCatalog {
  headers: string[]
  content: string[][]

  constructor (headers?: string[], content?: string[][]) {
    this.headers = headers || ['columna1']
    this.content = content || [['valor1']]
  }
}

export class CatalogCatalogGridItem extends CatalogGridItem {
  name: string
  domain: number
  domainName: string
  project: number
  projectName: string
  version: string
  source: string
  description: string
  creationDate: string
  updateDate: string
  grouping: boolean
  generalDomain: boolean
}

export class Catalog {
  id: number
  name: string
  domain: number
  project: number | null
  version: number
  source: number | null
  description: string
  data: DataCatalog
  creationDate: Date
  updateDate: Date
  grouping: boolean
  generalDomain: boolean

  static getInstanceForEdit () {
    const instance = new Catalog()
    instance.name = ''
    instance.domain = -1
    instance.project = null
    instance.version = 1
    instance.source = null
    instance.description = ''
    instance.data = new DataCatalog()
    return instance
  }
}

export class CatalogCatalogFilters {
  domain?: BasicEntity
  sort: string = 'id'
  name?: string
  project?: number = -1
  version?: number
  grouping?: boolean
}
